export default __webpack_public_path__ + "static/media/bazzle4.fd186c0f.png";